import { FC } from 'react';
import { Loader } from '@/components';
import styles from './Suspense.module.sass';

interface SuspenseProps {}

const Suspense: FC<SuspenseProps> = () => {
  return (
    <div className={styles.suspense}>
      <Loader size="large" />
    </div>
  );
};

export default Suspense;
